<template>
  

  <v-container fluid>


    <br>

      
      <ComponenteLoading :is-loading="loading" :message="mensaje_loading"></ComponenteLoading>

 
    
      <br><br>


        <v-data-table
        density="compact"
        :headers="cabecera_tabla_simulaciones"
        :items="lista_simulaciones"
        :search="search"
        class="elevation-1"        
      >






        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>{{$t('simulaciones.titulo')}}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>

            <v-btn  color="primary" class="resumen" dark @click="obtener_resumen">{{$t('simulacion.modulo.resultado.titulo_resumen')}}</v-btn>

            <v-btn  color="primary" dark @click="obtener_lista_simulaciones">{{$t('simulaciones.boton.recargar')}}</v-btn>
            
  
          </v-toolbar>
        </template>


        <template v-slot:item="{ item }">
  
          <tr>
          <td>{{ item.indice_simulacion }}</td>
          <td>{{ formatearNombreSimulacion(item) }}</td>           
          <td>{{ item.username }}</td>            
          <td>{{ item.status !== -1 ? calcularHoraLocal(item.last_update) : item.last_update }}</td>
          <!--<td>{{ this.decodifica_estado(item.status) }}</td>-->
          <td>
          
          <v-icon 
            v-if="item.status === 3" 
            class="spin-icon" 
            color="blue"
          >
            mdi-loading
          </v-icon>

          <v-icon v-else-if="item.status === 4" color="green">mdi-check-circle</v-icon>
          <v-icon v-else-if="item.status === -1" color="orange">mdi-pencil</v-icon>
          </td>
          
          
  
<td class="text-center">
  <div class="icon-container">
    <!-- Ícono para "Ver Resultado" -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon 
          v-if="item.status === 4" 
          color="blue" 
          @click="ver_resultado_simulacion(item)"
          v-bind="attrs" 
          v-on="on"
          class="clickable-icon"
        >
          mdi-eye
        </v-icon>


      </template>
      {{$t('simulaciones.boton.ver_resultado')}}
    </v-tooltip>

    <!-- Ícono para "Borrar Simulación" -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon 
          v-if="item.status === 4" 
          color="red" 
          @click="borrar_simulacion(item)" 
          v-bind="attrs" 
          v-on="on"
          class="clickable-icon"
        >
          mdi-delete
        </v-icon>

        <v-icon 
          v-if="item.status === -1" 
          color="red" 
          @click="borrar_simulacion_guardada(item)" 
          v-bind="attrs" 
          v-on="on"
          class="clickable-icon"
        >
          mdi-delete
        </v-icon>


      </template>
      {{$t('simulaciones.boton.borrar_simulacion')}}
    </v-tooltip>
  </div>
</td>


          </tr> 
  
        </template>

        </v-data-table>
       
        <!--<ComponenteSimulacion v-if="id_hija !== null" :id="id_hija" esHijo="1" :key="actualizar_componente_simulacion_hija"/>-->
        <!--<ComponenteSimulacion :id="id_hija" esHijo="1" :key="actualizar_componente_simulacion_hija"/>-->

        <router-view :key="$route.fullPath" name="simulacion_hija"></router-view>



    <!-- Modal -->
    <v-dialog v-model="dialogResumen" max-width="90%">
  <v-card style="min-width: 1000px; max-height: 90vh; overflow-y: auto;">

        <v-card-text>
          <div class="d-flex justify-end mb-4">
          <v-btn color="primary" @click="exportarExcel">
    {{$t('simulacion.barridos.boton_descargar')}}
  </v-btn>
</div>
          <v-card-title class="text-h6">{{$t('simulacion.barridos.resumen_titulo')}}</v-card-title>
          <v-data-table
            density="compact"
            :headers="headers"
            :items="items"
            class="elevation-1 custom-table" 
          >
        <template v-slot:[`item.barrido`] = "{ item, index }">
          <v-tooltip location="top" width="300px" variant="outlined">
            <template v-slot:activator="{ props }">
              <span v-bind="props" style="cursor: pointer">                    
                <div v-if="index == '0'">
                  {{ $t('simulacion.barridos.simulacion') }} {{ $t('simulacion.barridos.inicial') }}
                </div>
                <div v-else>
                  {{ $t('simulacion.barridos.simulacion') }} {{ index }}
                </div>                
              </span>
            </template>
            <span>{{ item.barrido }}</span>
          </v-tooltip>
        </template>
        </v-data-table>
          <ComponenteGrafica
            v-if="optionsGrafica"
            :options="optionsGrafica"
            :height="'400px'"
            class="mt-6"
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="resumen" @click="dialogResumen = false">{{$t('simulacion.barridos.boton_cerrar')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-container>




</template>


<script>
import store from '../store';
import axios from 'axios';
import '@vuepic/vue-datepicker/dist/main.css'
import ComponenteLoading from './ComponenteLoading.vue';
//import ComponenteSimulacion from './ComponenteSimulacion.vue';
import Swal from "sweetalert2";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import ComponenteGrafica from './ComponenteGrafica.vue';

export default {

    props: {
        id: {
          type: String,
          default: null
        },
    },


    data() {
        return {
          optionsGrafica: null,
          mensaje_loading: "",
          loading: false,
          contenido: 'hola mundo', // Definir las propiedades reactivas
          mode: 'light',

            lista_simulaciones: [],

            cabecera_tabla_simulaciones: [
              { title: "Nº", key: 'indice_simulacion' },
              { title: this.$t('simulaciones.tabla.nombre'), key: 'name' },            
              { title: this.$t('simulaciones.tabla.usuario'), key: 'username' },              
              { title: this.$t('simulaciones.tabla.fecha'), key: 'last_update' },
              { title: this.$t('simulaciones.tabla.estado'), key: 'status' },              
              { title: this.$t('simulaciones.tabla.acciones'), key: 'actions', sortable: false },
            ],



          isSaving: false,
            
          usuario_id: store.state.usuarioID,

          dialog: false,
          dialog_proceso: false,
          editedIndex: -1,


          dialogResumen: false,
          headers: [
            { title: 'Barrido', key: 'barrido' },
            { title: 'Capacidad almacenamiento (ton H2)', key: 'CAP_ALM' },
            { title: 'Horas equivalentes electrolizador (h)', key: 'HEQ' },
            { title: 'Horas de funcionamiento del electrolizador (h)', key: 'HFUN' },
            { title: 'LCOH', key: 'LCOH' },
            { title: 'NPV', key: 'NPV' },
            { title: 'TIR', key: 'TIR' },
            { title: 'Demanda H2 no suministrada (ton)', key: 'HNS' },
            { title: 'Potencia contratada PPA1 (MW)', key: 'PC_PPA1' },
            { title: 'Potencia contratada PPA2 (MW)', key: 'PC_PPA2' },
            { title: 'Potencia contratada PPA3 (MW)', key: 'PC_PPA3' },
            { title: 'Potencia baterías (MW)', key: 'PI_BAT' },
            { title: 'Potencia electrolizador (MW)', key: 'PI_EL' },
            { title: 'Potencia planta eólica (MW)', key: 'PI_EOL' },
            { title: 'Potencia planta solar fotovoltaica (MW)', key: 'PI_PV' },
             // === NUEVAS COLUMNAS (AL FINAL) ===
            { title: 'Energía comprada a red (MWh)', key: 'Energía comprada a red (MWh)' },
            { title: 'Energía consumida PPAs (MWh)',  key: 'Energía consumida PPAs (MWh)' },
            { title: 'Energía consumida RES (MWh)',   key: 'Energía consumida RES (MWh)' },
          ],

          items: [],

          id_hija: 0,
          actualizar_componente_simulacion_hija: null,
         
        };
      },

  watch: {    
    
    '$i18n.locale'() {
      
      this.cabecera_tabla_simulaciones = [
        { title: "Nº", key: 'indice_simulacion' },
        { title: this.$t('simulaciones.tabla.nombre'), key: 'name' },            
        { title: this.$t('simulaciones.tabla.usuario'), key: 'username' },              
        { title: this.$t('simulaciones.tabla.fecha'), key: 'last_update' },
        { title: this.$t('simulaciones.tabla.estado'), key: 'status' },              
        { title: this.$t('simulaciones.tabla.acciones'), key: 'actions', sortable: false },
      ];



    },



  },


  components: {
    ComponenteLoading,
    ComponenteGrafica
    //ComponenteSimulacion
  },
    mounted(){

        
        this.obtener_lista_simulaciones()

    },


    
    methods: {


      obtener_resumen() {
        this.loading = true;  
        this.mensaje_loading = this.$t('mensajes.obteniendo_lista');
        
        this.items = [
          { id: 1, nombre: 'Variable A', valor: 100 },
          { id: 2, nombre: 'Variable B', valor: 200 },
          { id: 3, nombre: 'Variable C', valor: 300 },
        ]

        


          
          axios(
              {
                  method: 'get',
                  url: process.env.VUE_APP_API_BASE_URL + '/api/descargar-resumen-barrido?username=' + store.state.usuarioNombre + "&id_padre=" + this.id,    
                  withCredentials: true,                   
                  headers: { 
                    Authorization: "Bearer " + store.state.token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'                
                  },      
              }
          )
         .then((response) => {    
            this.cargando = false;
            let myObject = response.data;
            console.log("Resumen barrido recibido:", myObject);
            console.table(myObject);
            console.log("Tipos id ->", myObject.map(r => ({ barrido: r.barrido, id: r.id, tipo: typeof r.id })));
            console.log("this.id (prop):", this.id, "tipo:", typeof this.id);
            // Ordenar por fecha de creación ascendente
            myObject.sort((a, b) => new Date(a.created) - new Date(b.created));

            // Formatear todos los items
            const itemsFormateados = myObject.map((item, index) => {
              const name = item.barrido || ''; 
              const matchID = name.match(/ID(\d+)/);
              const idPadre = matchID ? `ID${matchID[1]}` : '';

              const eolica = name.match(/eolica=(\d+)/i);
              const solar = name.match(/solar=(\d+)/i);
              const elec = name.match(/elec=(\d+)/i);

              const valores = [
                `${this.$t('simulacion.barridos.eolica')} = ${!eolica || eolica[1] === '0' || eolica[1].toLowerCase() === 'none' ? 'inicial' : eolica[1]}`,
                `${this.$t('simulacion.barridos.solar')} = ${!solar || solar[1] === '0' || solar[1].toLowerCase() === 'none' ? 'inicial' : solar[1]}`,
                `${this.$t('simulacion.barridos.electrolizador')} = ${!elec || elec[1] === '0' || elec[1].toLowerCase() === 'none' ? 'inicial' : elec[1]}`
              ].join(' ');

              return {
                ...item,
                indice_simulacion: index,
                barrido: `${idPadre} ${valores}`
              };
            });

            //  Detectar padre
            const padre = itemsFormateados.find(item => item.id === this.id);
            const itemsSinPadre = itemsFormateados.filter(item => item.id != this.id);


            this.items = itemsFormateados; 
            this.itemPadre = padre; 
            this.itemsSinPadre = itemsSinPadre; 

            // Actualizar indices
            this.lista_simulaciones.forEach(sim => {
              const match = this.items.find(i => i.id === sim.id);
              if (match) {
                sim.indice_simulacion = match.indice_simulacion;
              }
            });

            console.log("Items con padre:", this.items);
            console.log("Items sin padre (gráfica):", this.itemsSinPadre);

 /* this.optionsGrafica = {
  title: {
    text: this.$t('simulacion.barridos.titulo_grafica'),
    left: 'center'
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross'
    },
    formatter: (params) => {
      const index = params[0].dataIndex;
      const nombreCompleto = this.itemsSinPadre[index]?.barrido || `${this.$t('simulacion.barridos.simulacion')} ${index + 1}`;
      const tir = params[0].value;
      const lcoh = params[1].value;
      return `
        <b>${nombreCompleto}</b><br>
        ${params[0].seriesName}: ${tir.toFixed(2)} %<br>
        ${params[1].seriesName}: ${lcoh.toFixed(2)} €/kg H₂
      `;
    }
  },
  legend: {
    data: ['TIR', 'LCOH'],
    top: 30
  },
  grid: {
    top: 100,
    bottom: 60,
    left: 60,
    right: 60,
    containLabel: true
  },
  xAxis: {
    type: 'category',
    data: itemsSinPadre.map((item, index) => `${this.$t('simulacion.barridos.simulacion')} ${index + 1}`),
    //data: this.items.map((item, index) => 
      //`${index == 0 ? 'Padre: ' : ''}${this.$t('simulacion.barridos.simulacion')} ${index}`
    //),
    axisLabel: {
      interval: 0,
      
    }
  },
  yAxis: [
    { 
      type: 'value',
      name: 'TIR (%)',
      position: 'left',
      axisLine: {
        show: true,
        lineStyle: {
          color: '#f57c00' 
        },
      },
      
      axisLabel: {
        formatter: '{value}'
      },
      splitLine: {
        show: false 
      },
      min: () => {
      const vals = this.items.map(i => parseFloat(i.TIR));
      return Math.floor(Math.min(...vals)) - 5;
    },
    max: () => {
      const vals = this.items.map(i => parseFloat(i.TIR));
      return Math.ceil(Math.max(...vals)) + 5;
    }
    },
    { // Eje derecho para LCOH
      type: 'value',
      name: 'LCOH (€/kg H₂)',
      position: 'right',
      axisLine: {
        show: true,
        lineStyle: {
          color: '#1976d2' 
        }
      },
      axisLabel: {
        formatter: '{value}'
      },
      splitLine: {
        show: false 
      },
      min: 0, 
      max: () => {
        const vals = this.items.map(i => parseFloat(i.LCOH));
      const maxVal = Math.max(...vals);
      return Math.ceil(maxVal) + 1;
      },
      offset: 0 
    }
  ],
  series: [
    {
  name: 'TIR inicial',
  type: 'line',
  yAxisIndex: 0,
  data: this.itemsSinPadre.map(() => parseFloat(this.items[0]?.TIR || 0)),
  lineStyle: {
    type: 'dashed',
    color: '#f57c00',
    width: 2
  },
  symbol: 'none',
  tooltip: {
    show: false
  }
},
{
  name: 'LCOH inicial',
  type: 'line',
  yAxisIndex: 1,
  data: this.itemsSinPadre.map(() => parseFloat(this.items[0]?.LCOH || 0)),
  lineStyle: {
    type: 'dashed',
    color: '#1976d2',
    width: 2
  },
  symbol: 'none',
  tooltip: {
    show: false
  }
},
    {
      name: 'TIR',
      type: 'line',
      yAxisIndex: 0, 
      data: this.itemsSinPadre.map(item => parseFloat(item.TIR) || 0),
      lineStyle: {
        color: '#f57c00',
        width: 3
      },
      itemStyle: {
      color: '#f57c00' 
    },
      symbol: 'circle',
      symbolSize: 8,
      label: {
        show: false,
        position: 'bottom',
        formatter: ({ value }) => `${value.toFixed(1)}`
      }
    },
    {
      name: 'LCOH',
      type: 'line',
      yAxisIndex: 1, 
      data: this.itemsSinPadre.map(item => parseFloat(item.LCOH) || 0)
,
      lineStyle: {
        color: '#1976d2',
        width: 3
      },
      itemStyle: {
    color: '#1976d2' 
  },
      symbol: 'diamond',
      symbolSize: 10,
      label: {
        show: false,
        position: 'top',
        formatter: ({ value }) => `${value.toFixed(2)}`
      }
    }
  ],
  
}; */

this.optionsGrafica = {
  title: {
    text: this.$t('simulacion.barridos.titulo_grafica'), 
    left: 'center'
  },
  tooltip: {
    trigger: 'item', 
    formatter: (params) => {
     
      console.log("Params: ", params)
      const isOriginal = params.dataIndex === 0 && params.seriesName === 'Simulación Original';
      const nombreCompleto = isOriginal 
                             ? this.$t('simulacion.barridos.simulacion_original') 
                             : this.items[params.seriesIndex]?.barrido || `${this.$t('simulacion.barridos.simulacion')} ${params.dataIndex + 1}`;
      const tir = params.value[1];
      const lcoh = params.value[0]; 

      return `
        <b>${nombreCompleto}</b><br>
        TIR: ${tir.toFixed(2)} %<br>
        LCOH: ${lcoh.toFixed(2)} €/kg H₂
      `;
    }
  },
  legend: {
    //data: [this.$t('simulacion.barridos.simulaciones'), this.$t('simulacion.barridos.simulacion_original')], 

     data: [
      { name: this.$t('simulacion.barridos.simulacion_original') },
      // Aquí se generarán dinámicamente las entradas para cada simulación individual
      ...this.items.slice(1).map((item, index) => ({
        
        // El nombre en la leyenda será el de la simulación específica
        name: `Sim ${index + 1}`,
        icon: 'circle' // Opcional: para que el icono en la leyenda sea un círculo
      }))
    ],
    top: 30,
    bottom:50,
    
    type:'scroll',
  //   itemGap: 10,    // <--- Espacio horizontal entre los elementos de la leyenda
  //itemWidth: 25,  // <--- Ancho de cada elemento de la leyenda (icono + texto). Ajusta según el largo de tus nombres.
  itemHeight: 14,
  },
  grid: {
    top: 100,
    bottom: 60,
    left: 60,
    right: 120,
    containLabel: true
  },
  xAxis: {
    type: 'value', 
    name: 'LCOH (€/kg H₂)',
    
    nameGap: 25,
    rotate:45,
    axisLabel: {
       margin: 10,
      formatter: '{value}',
       interval: 0,
      
    },
    min: 0,
    max: () => {
      const vals = this.items.map(i => parseFloat(i.LCOH));
      const maxVal = Math.max(...vals);
      return Math.ceil(maxVal) + 1;
    }
  },
  yAxis: { 
    type: 'value',
    name: 'TIR (%)',
    axisLabel: {
      formatter: '{value}'
    },
    min: () => {
      const vals = this.items.map(i => parseFloat(i.TIR));
      return Math.floor(Math.min(...vals)) - 5;
    },
    max: () => {
      const vals = this.items.map(i => parseFloat(i.TIR));
      return Math.ceil(Math.max(...vals)) + 5;
    }
  },
  series: [
    /* {
      name: item.barrido || `${this.$t('simulacion.barridos.simulacion')} ${index + 1}`, 
      type: 'scatter', 
      data: this.items.slice(1).map(item => [parseFloat(item.LCOH) || 0, parseFloat(item.TIR) || 0]), // Datos para el scatter plot, excluyendo el primero
      itemStyle: {
        color: (params) => {
          // params.dataIndex es el índice del punto DENTRO de esta serie (slice(1))
          const hue = (params.dataIndex * 137) % 360;
          return `hsl(${hue}, 70%, 50%)`;
        }  
      },
      symbol: 'circle', 
      symbolSize: 8,
      tooltip: {
        show: true  
      },
       label: {
        show: true, // Muestra el label
        position: 'top', // Posición del label: encima del punto
        formatter: (params) => {
          console.log("Params 2: ", params)
          // params.data[2] es el tercer elemento que hemos añadido al array de datos [LCOH, TIR, numeroSimulacion]
          return params.dataIndex+1;
        },
        fontSize: 10, // Tamaño de la fuente del número
        color: '#333', // Color del texto del número
        // Puedes añadir background o border si necesitas que resalte más
        // backgroundColor: 'rgba(255, 255, 255, 0.7)',
        // borderColor: '#ccc',
        // borderWidth: 1,
        // padding: [2, 4]
      },
      // Si quieres que el label se superponga sin problemas con otros elementos
      // También puedes usar `z: 10` para asegurarte de que esté por encima de otros elementos
      z: 10
    
    }, */
    {
      name: this.$t('simulacion.barridos.simulacion_original'), 
      type: 'scatter', 
      data: [[parseFloat(this.items[0]?.LCOH) || 0, parseFloat(this.items[0]?.TIR) || 0]], 
      itemStyle: {
        color: '#f57c00' 
      },
      symbol: 'star', 
      symbolSize: 15, 
      tooltip: {
        show: true 
      },
      z:11
    },
    ...this.items.slice(1).map((item, index) => {
        // Generamos un color único para cada simulación
        const hue = ((index + 1) * 137) % 360; 
        const individualColor = `hsl(${hue}, 70%, 50%)`;
      console.log("Item: ", item)
        //Tambien se puede usar item.barrido aqui y en legend para poner el nombre completo
        let simulationName =  `Sim ${index + 1}`;
      
        return {
            name: simulationName,
            type: 'scatter',
           
            data: [[parseFloat(item.LCOH) || 0, parseFloat(item.TIR) || 0]],
            itemStyle: {
                color: individualColor // Aplicamos el color único a esta serie
            },
            symbol: 'circle', 
            symbolSize: 8,
            tooltip: { show: true },
            label: {
                // Configuración de la etiqueta para mostrar el número de la simulación
                show: true,
                position: 'top',
                formatter: `${index + 1}`, 
                fontSize: 10,
                color: '#333',
            },
            z: 9 
        };
    })
  ],
  dataZoom: [
    {
      // Zoom del eje X
      type: 'inside',
      xAxisIndex: [0], 
      yAxisIndex: [],  // No controla el eje Y
      filterMode: 'none' 
    },
        {
      // Zoom del eje y
      type: 'inside',
      xAxisIndex: [],  // No controla el eje X
      yAxisIndex: [0], 
      filterMode: 'none' 
    },
    //Sliders para manejar el zoom y el filtro de datos
    {
      type: 'slider', 
      xAxisIndex: [0],
      show: true,
      height: 20,
      bottom: 20, 
      start: 0,
      end: 100
    },
    {
      type: 'slider', 
      yAxisIndex: [0],
      show: true,
      width: 20,
      left: 0, 
      end: 100
    }
  ]

};
this.dialogResumen = true
})
 .catch(error => {
        console.error("Error al obtener resumen:", error);
       
    })
    .finally(() => {
        
        this.loading = false;
        this.mensaje_loading = "";
    });
},

  
    


      


      decodifica_estado(estado){
        if (estado == 1) return this.$t('simulaciones.estados.creada');
        if (estado == 2) return this.$t('simulaciones.estados.guardada');
        if (estado == 3) return this.$t('simulaciones.estados.en_ejecucion');
        if (estado == 4) return this.$t('simulaciones.estados.ejecutada_ok');
        if (estado == 5) return this.$t('simulaciones.estados.ejecutada_nok');
        if (estado == 6) return this.$t('simulaciones.estados.cancelada');
        if (estado == 7) return this.$t('simulaciones.estados.borrada');        
      },



      obtener_lista_simulaciones(){
        

          this.loading = true;
          this.mensaje_loading = this.$t('mensajes.obteniendo_lista');
          axios(
              {
                  method: 'get',
                  url: process.env.VUE_APP_API_BASE_URL + '/api/simulacion?username=' + store.state.usuarioNombre + "&id_padre=" + this.id,    
                  withCredentials: true,                   
                  headers: { 
                    Authorization: "Bearer " + store.state.token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'                
                  },      
              }
          )
          .then((response) => {    
              this.cargando = false;
              let myObject = response.data;
              this.lista_simulaciones = myObject.filter(item => item.status !== 7);
              console.log("Lista de simulaciones recibida:", this.lista_simulaciones);
              this.loading = false;     
              this.mensaje_loading = ""
          })



      },


      ver_resultado_simulacion(item){       
        //alert("Ver resultado: " + item.id) 
        //this.$emit('ver-resultado', item.id)

        this.id_hija = 0;
        this.id_hija = item.id
        this.actualizar_componente_simulacion_hija = Date.now();

        this.$router.push('/resultado-simulacion/' + this.id + "/hija/" + this.id_hija );

        /*
        this.$router.push({
          name: 'ComponenteSimulacionHija',
          params: { id: this.id_hija }          
        });
        */



      },





    async borrar_simulacion(item) {

      try {
        

        this.errorMessage = null;
                
        try {
          const result = await Swal.fire({
            title: this.$t('mensajes.estas_seguro'),
            text: this.$t('mensajes.borrar_simulacion') + item.id,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t('comun.boton_ok'),
            cancelButtonText: this.$t('comun.boton_cancelar'),
          });

          if (result.isConfirmed) {
            this.loading = true;
            
            // Enviar los datos al servidor            
            await axios({
              method: "delete",
              url: process.env.VUE_APP_API_BASE_URL + "/api/borrar-simulacion/" + item.id,
              withCredentials: true,
              headers: {
                Authorization: "Bearer " + store.state.token,
                "Access-Control-Allow-Origin": "*",
                'Content-Type': 'application/json'
              },
            });
                      
            this.loading = false;
            this.obtener_lista_simulaciones()
            // Mostrar mensaje de éxito
            Swal.fire(this.$t('mensajes.borrar_simulacion_ok_titulo'), this.$t('mensajes.borrar_simulacion_ok_subtitulo'), "success");
            this.$router.push('/'); //Nos vamos a la pagina de home
          }
        } catch (error) {
          console.error("Error al borrar la simulación:", error);
          this.loading = false;

          // Mostrar mensaje de error
          Swal.fire("Error", this.$t('mensajes.borrar_simulacion_nok'), "error");
        }
        
      } catch (error) {
        // Maneja errores de validación
        this.errorMessage = error.inner.map((e) => e.message).join(", ");
        console.error("Errores de validación:", this.errorMessage);
        Swal.fire("Errores de validacion", this.errorMessage, "error");
      }








    },



    calcularHoraLocal(fechaString) {
        // Convertir la fecha del string al formato Date
        const fechaUTC = new Date(fechaString.replace(" ", "T") + "Z");
        
        // Obtener la fecha local en formato ISO
        const fechaLocal = new Date(fechaUTC.toLocaleString("en-US", { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }));

        // Formatear la fecha local al mismo formato que el original
        const year = fechaLocal.getFullYear();
        const month = String(fechaLocal.getMonth() + 1).padStart(2, "0");
        const day = String(fechaLocal.getDate()).padStart(2, "0");
        const hours = String(fechaLocal.getHours()).padStart(2, "0");
        const minutes = String(fechaLocal.getMinutes()).padStart(2, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}`;
    },

    async descargarReadme() {
      const zip = new JSZip();
      const docsFolder = zip.folder("docs"); // Carpeta dentro del ZIP
      const assetsFolder = zip.folder("docs/assets"); // Carpeta de imágenes

      try {
      
        const readmeResponse = await axios.get("/docs/README.md", {
          responseType: "text",
        });
        docsFolder.file("README.md", readmeResponse.data);

        const imagenes = await this.obtenerListaImagenes();

        for (const img of imagenes) {
          const imgResponse = await axios.get(`/docs/assets/${img}`, {
            responseType: "blob",
          });
          const imgBlob = new Blob([imgResponse.data]);
          const arrayBuffer = await imgBlob.arrayBuffer();
          assetsFolder.file(img, arrayBuffer);
        }
        const zipBlob = await zip.generateAsync({ type: "blob" });
        saveAs(zipBlob, "ralph_manual.zip");

      } catch (error) {
        console.error("Error al descargar el README o las imágenes", error);
      }
    },

    async obtenerListaImagenes() {
      try {
        const response = await axios.get("/docs/assets/"); 
        return response.data; 
      } catch (error) {
        console.error("Error al obtener la lista de imágenes:", error);
        return []; 
      }
    },

   formatearNombreSimulacion(item) {
      if (!item || !item.name) return '';

      // Extraer solo el ID del barrido
      const matchID = item.name.match(/ID(\d+)/);
      const idPadre = matchID ? `ID${matchID[1]}` : '';

      const eolica = item.name.match(/eolica=(\d+)/i);
      const solar = item.name.match(/solar=(\d+)/i);
      const elec = item.name.match(/elec=(\d+)/i);

     const valores = [
  `Eólica = ${!eolica || eolica[1].toLowerCase() === 'none' || eolica[1] === '0' ? 'inicial' : eolica[1]}`,
  `Solar = ${!solar || solar[1].toLowerCase() === 'none' || solar[1] === '0' ? 'inicial' : solar[1]}`,
  `Electrolizador = ${!elec || elec[1].toLowerCase() === 'none' || elec[1] === '0' ? 'inicial' : elec[1]}`
].join(' ');

      return `${idPadre} ${valores}`;
    },





   exportarExcel() {
  const data = [this.headers.map(h => h.title)];

  this.items.forEach(item => {
    data.push(this.headers.map(h => item[h.key] ?? ""));
  });

  const ws = XLSX.utils.aoa_to_sheet(data);

  // Ancho de columna en caracteres
  ws['!cols'] = this.headers.map(() => ({ wch: 35 })); 

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Resumen");

  XLSX.writeFile(wb, "resumen_simulacion_barrido.xlsx");
},






    },
    







}
</script>


<style scoped>
.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-table {
  background-color: #f5f5f5; /* Color de fondo gris claro */
  text-align: center;
  border: 1px solid rgb(114, 114, 114);
}

/* Encabezados de tabla */
:deep(.custom-table .v-data-table__th) {
  background-color: rgb(197, 223, 252);
  border: 1px solid rgb(197, 192, 192);
  padding: 5px;
  text-align: center; /* Para compatibilidad básica */
}

:deep(.custom-table .v-data-table__th .v-data-table-header__content) {
  justify-content: center; /* Esto alinea el texto al centro usando flexbox */
}

/* Filas pares */
:deep(.custom-table .v-data-table__tr:nth-child(even)) {
  background-color: #f9f9f9;
  border: 1px solid rgb(221, 221, 221);
}

/* Filas impares */
:deep(.custom-table .v-data-table__tr:nth-child(odd)) {
  background-color: #f1f4f5;
  border: 1px solid rgb(114, 114, 114);
}

/* Borde exterior de la tabla */
:deep(.custom-table .v-data-table__wrapper) {
  border: 1px solid #e0e0e0 !important;
}

/* Fila par desde fuera de la clase .custom-table (extra) */
:deep(.v-data-table__tr:nth-child(even)) {
  background-color: #f9f9f9;
}

/* Encabezados */
:deep(.v-data-table-header th) {
  color: white !important;
  text-align: center;
}

/* Animación simple para el ícono */
.spin-icon {
  animation: spin 1s linear infinite;
}

.resumen {
  box-shadow: 0px 0px 6px rgba(0, 0, 139, 0.5); 
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}




</style>